import type { EventInfo } from '@/types/event';
import type { SearchedEventDetail } from '@/types/search';

export const transformEventSearchResponse = (events: SearchedEventDetail[]): EventInfo[] => {
	return events.map((event: SearchedEventDetail): EventInfo => {
		const timezone = event.start.timezone;
		const displayDate = formatEventCardDisplayDateRange(event.start.utc, event.end.utc, timezone);
		const displayTime = formatEventCardDisplayTimeRange(event.start.utc, event.end.utc, timezone);
		const status = derivedEventSoldoutStatus(event.status, event.end);
		const isSoldout = event.status === EVENT_STATUS.SOLD_OUT;
		const address = event.address || event.locationSettings?.venueAddress || '';
		const city = event.locationSettings?.venueCity || event.locationSettings?.venueCityShort || '';
		const state = event.locationSettings?.venueStateShort || '';

		return {
			locationType: event.locationType,
			id: event.id,
			groupId: event.group.id,
			groupName: event.group.name,
			groupLogo: event.group.logo,
			status,
			coverImageUrl: event.coverImage,
			name: event.name,
			address,
			city,
			state,
			displayDate,
			displayTime,
			displayTimezone: getTimezoneAbbreviation(timezone),
			isHappeningNow: calculateHappeningNow(event.start, event.end),
			isEventSeries: event.badges.isSeries,
			isEventFree: event.badges.isFree,
			isSoldout,
			avatarUrl: event.organizer.avatar,
			organizer: event.organizer.nickname,
			organizerId: event.organizer.id,
		};
	});
};